// A calming low chime for the Overwhelm flow. Web Audio, no asset deps.
//
// Two stacked sine waves (440Hz + 660Hz, a soft perfect-fifth) with a
// gentle attack-and-release envelope over 1.2s. Deliberately quiet.
// Never throws — audio is best-effort UX, not a critical path.
let _ctx = null;
function ctx() {
    if (_ctx) return _ctx;
    try {
        const Ctor = window.AudioContext || window.webkitAudioContext;
        _ctx = new Ctor();
    } catch { _ctx = null; }
    return _ctx;
}

export function playOverwhelmChime() {
    try {
        const c = ctx();
        if (!c) return;
        // Some browsers suspend the context until a user gesture; the panic
        // button IS a user gesture so it should resume cleanly.
        if (c.state === "suspended") { c.resume().catch(() => {}); }

        const now = c.currentTime;
        const master = c.createGain();
        master.gain.value = 0;
        master.connect(c.destination);
        // Soft attack + long release
        master.gain.setValueAtTime(0, now);
        master.gain.linearRampToValueAtTime(0.16, now + 0.18);
        master.gain.linearRampToValueAtTime(0, now + 1.2);

        [440, 660].forEach((freq, i) => {
            const o = c.createOscillator();
            o.type = "sine";
            o.frequency.setValueAtTime(freq, now);
            const g = c.createGain();
            g.gain.value = i === 0 ? 1 : 0.55; // upper voice softer
            o.connect(g);
            g.connect(master);
            o.start(now);
            o.stop(now + 1.3);
        });
    } catch { /* ignore — audio is best-effort */ }
}
